import { useState } from 'react';
import { GoldenSourceHelper } from '../../../app/Switch_Core_React_Standards';

export const useBatchProcessor = () => {
    const [status, setStatus] = useState('idle'); 
    const [progress, setProgress] = useState(0);
    const [error, setError] = useState(null);

    const API_BASE = process.env.REACT_APP_API_BASE_URL || '';
    const SITE_KEY = process.env.REACT_APP_SITE_KEY; 

    /**
     * Executes the full Batch Lifecycle:
     * 1. Handshake (Initialization)
     * 2. Discovery (GoldenSource Normalization)
     * 3. Courier (S3 Upload)
     */
    const startBatchSequence = async (payload) => {
        const { file, batchType, manifestName } = payload;

        const sessionID = sessionStorage.getItem("SEC_SESSION_ID");
        const siteUserGuid = sessionStorage.getItem("SEC_USER_GUID");

        try {
            setError(null);
            setStatus('initializing');

            // --- STEP 1: THE HANDSHAKE ---
            const handshakeUrl = `${API_BASE}/api/v1/batch/initialize-batch`;
            console.log("Initiating Handshake with payload:", {handshakeUrl});
            const response = await fetch(handshakeUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'SITE-KEY': SITE_KEY
                },
                body: JSON.stringify({
                    BatchType: batchType,
                    SiteUserGuid: siteUserGuid, 
                    SessionID: sessionID,       
                    ManifestFileName: manifestName,
                    FileCount: 1, 
                    TotalBatchSizeMB: parseFloat((file.size / (1024 * 1024)).toFixed(2))
                })
            });

            if (!response.ok) {
                throw new Error(`BFF Route Error: ${response.status} at ${handshakeUrl}`);
            }

            const rawJson = await response.json();
            
            // 🎯 THE DISCOVERY: Normalize the ASP.NET Core response
            const res = GoldenSourceHelper.normalize(rawJson);

            if (!res.success) {
                throw new Error(res.message || "BFF Handshake rejected the request.");
            }

            // 🎯 THE EXTRACTION: Safely get the ID regardless of casing
            const batchId = res.getProp('assignedBatchID');

            if (!batchId) {
                console.error("Discovery Failed. Raw Response:", rawJson);
                throw new Error("Registration Failure: No BatchID found in the normalized payload.");
            }

            // --- STEP 2: THE COURIER (S3 Upload) ---
            setStatus('uploading');
            setProgress(20);

            const formData = new FormData();
            formData.append('file', file);
            formData.append('batchId', batchId);

            const courierUrl = `${API_BASE}/api/v1/sustina/upload`;

            const courierResponse = await fetch(courierUrl, {
                method: 'POST',
                headers: { 'SITE-KEY': SITE_KEY },
                body: formData
            });

            if (!courierResponse.ok) {
                throw new Error(`Courier Error: ${courierResponse.statusText}`);
            }

            setProgress(100);
            setStatus('completed');
            
            return { success: true, batchId };

        } catch (err) {
            console.error("useBatchProcessor Failure:", err.message);
            setError(err.message);
            setStatus('error');
            throw err; 
        }
    };

    return { startBatchSequence, status, progress, error };
};